import baseService from './apiService';
import { Get_Token } from 'resolvers/Get_Token';

export async function getOwners() {
    const response = await baseService.get('/businesses/owners', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export const validatePhoneNumber = async phone => {
    if (process.env.REACT_APP_API_URL !== process.env.REACT_APP_API_URL_PRODUCTION) return true;
    if (phone?.length !== 10) return false;
    const response = await baseService.post(
        'users/exists/phone',
        { phoneNumber: phone },
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data.available;
};
